const StringLocaleBr = {
  install (Vue) {
    Vue.prototype.$toLocaleStringBr = this.toLocaleStringBr.bind(this)
    Vue.prototype.$validarFloat = this.validarFloat.bind(this)
  },

  validarFloat (value) {
    if (typeof value === 'string') {
      if (value.includes(',') && value.includes('.')) {
        value = value.replace(/\./g, '').replace(',', '.')
      } else if (value.includes('.')) {
        value = value.replace(',', '')
      } else if (value.includes(',')) {
        value = value.replace(',', '.')
      }
    }

    const parsed = parseFloat(value)
    return isNaN(parsed) ? null : parsed
  },

  toLocaleStringBr (value) {
    if (value === null || value === undefined || value === '') {
      return ''
    }
    value = this.validarFloat(value)

    if (value < 0 || isNaN(value)) {
      return ''
    }

    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  }
}

export default StringLocaleBr
